import {
    CHANGE_STORE_CREDITS_PAGE,
    GET_ALL_STORE_CREDITS,
    GET_CUSTOMER_ALL_PAYMENTS,
    GET_CUSTOMER_ALL_UNPAID_ORDERS,
    GET_ONE_STORE_CREDIT,
    SEARCH_STORE_CREDITS,
} from '../types'

const initialState = {
    storeCredits: null,
    storeCredit: null,
    customerAllUnpaidOrders: null,
    customerAllPayments: null,
    pages: '',
    page: '',
    count: '',
    keyword: '',
}

export default function storeCreditReducer(state = initialState, action) {
    const { type, payload } = action
    switch (type) {
        case GET_ALL_STORE_CREDITS:
            return {
                ...state,
                storeCredits: payload.storeCredits,
                pages: payload.pages,
                page: payload.page,
                count: payload.count,
                keyword: payload.keyword,
                storeCredit: null,
            }
        case SEARCH_STORE_CREDITS:
            return {
                ...state,
                keyword: payload.keyword,
                page: 1,
            }
        case CHANGE_STORE_CREDITS_PAGE:
            return {
                ...state,
                page: payload,
            }
        case GET_ONE_STORE_CREDIT:
            return {
                ...state,
                storeCredit: payload,
            }
        case GET_CUSTOMER_ALL_UNPAID_ORDERS:
            return {
                ...state,
                customerAllUnpaidOrders: payload,
            }
        case GET_CUSTOMER_ALL_PAYMENTS:
            return {
                ...state,
                customerAllPayments: payload,
            }
        default:
            return state
    }
}
